<template>
  <ContactoPopup />
  <LinksPopup
     />
  <div class="row allaction align-center" id="linksbar">
    <div class="small-12 medium-12 large-10 columns quicklinks2">
      <router-link class="quicklink2" to="/equipa">
        <img src="@/assets/images/icons_bibuma-1.png" />
        <h1>{{ $t("UMA_LANG_BIBLIOTECA_EQUIPA") }}</h1>
      </router-link>
      <a class="quicklink2" data-open="contactoPopup">
        <img src="@/assets/images/icon_sasuma2.png" />
        <h1>{{ $t("UMA_LANG_SASUMA_HOME_FOOTER_CONTACTOSEHORARIOS") }}</h1>
      </a>
      <a class="quicklink2" target="blank"
        href="https://testuma.sharepoint.com/:b:/s/reitoria/Ed70lOxDb1hCnGI_2ctiJB8Bpl5Oqa3GMqA-ZMyng7k0VA">
        <img src="@/assets/images/icon_sasuma3.png" />
        <h1>{{ $t("UMA_LANG_SASUMA_HOME_FOOTER_PLANOCONTIGENCIA") }}</h1>
      </a>
      <router-link class="quicklink2" to="/documentacao">
        <img src="@/assets/images/icon_sasuma5.png" />
        <h1>{{ $t("UMA_LANG_SASUMA_HOME_FOOTER_DOCUMENTACAO") }}</h1>
      </router-link>
      <a class="quicklink2" data-open="linksPopup">
        <img src="@/assets/images/icons_sas88.png" />
        <h1>{{ $t("UMA_LANG_SASUMA_HOME_FOOTER_LIGACOES") }}</h1>
      </a>
    </div>
  </div>
</template>

<script>
import ContactoPopup from "@/components/ContactoPopup.vue";
import LinksPopup from "@/components/LinksPopup.vue";

export default {
  components:{
    ContactoPopup,
    LinksPopup
  },
  setup() {

    return {}
  }
}
</script>

<style lang="scss" scoped>
.allaction {
  background-color: #06546bd1;
  height: 300px;
  max-width: 100%;
}

.quicklinks2 {
  display: flex;
  flex-wrap: wrap;
}

.quicklink2 {
  display: flex;
  /*flex: 1 0 21%;*/
  flex: 1 0 20%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.quicklink2 img {
  width: 100px;
  padding-bottom: 10px;
}


.quicklink2 h1 {
  font-family: "Montserrat";
  font-size: 18px;
  text-align: center;
  color: #ffffffcf;
}

.bib_info_morada {
  font-family: 'Montserrat';
  padding-top: 10px;
  margin-bottom: 20px;
}

.quicklink2:hover img {
  width: 110px;
}

.quicklink2:hover h1 {
  color: #ffffff;
}

@media (max-width: 767px) {

  .quicklink2 {
    flex: 1 0 100%;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 30px;
  }

  .quicklink2 img {
    width: 55px;
    margin-right: 5px;
  }

  .allaction {
    padding-top: 25px;
    padding-bottom: 25px;
    height: auto;
  }

  .quicklink2 h1 {
    color: #ffffffc9;
    margin-bottom: 0px;
    font-family: "Montserrat";
    font-size: 15px;
    letter-spacing: 0.3px;
    display: contents;
  }

  .quicklink2:hover img {
    width: 55px;
  }
}
</style>